module.exports = "<itpx-pagebase [message]=\"'Privacy Policy'\">\n\n  <page-base-content>\n    <div class=\"privacy-policy-container\">\n      <div>\n        <div [innerHTML]=\"privacyPolicy\"></div>\n        <div class=\"last-update\" *ngIf=\"lastUpdate\">Last Updated: {{lastUpdate | isoToDate}}</div>\n      </div>\n    </div>\n  </page-base-content>\n</itpx-pagebase>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/privacy-policy/privacy-policy.component.html
// module id = 909
// module chunks = 0